import { Grid } from '@mui/material';

import { VSpacer } from '@nx-smartmonkey/ui';
import { AnalyticsBinTypeContainer } from './AnalyticsBinTypeContainer';
import { AnalyticsDateRangeContainer } from './AnalyticsDateRangeContainer';
import { AnalyticsDistance } from './AnalyticsDistance';
import { AnalyticsEmissions } from './AnalyticsEmissions';
import { AnalyticsStops } from './AnalyticsStops';
import { AnalyticsHeader } from './header/AnalyticsHeader';
import { useAnalyticsFilters } from './hooks/useAnalyticsFilters';

export const Analytics = () => {
  const { tab } = useAnalyticsFilters();

  return (
    <Grid
      style={{
        height: `100%`,
        width: `100%`,
        overflowY: `hidden`,
        background: `linear-gradient(180deg, rgba(64, 104, 103, 0.90) 0%, #072120 22%`,
      }}
    >
      <Grid
        container
        wrap="nowrap"
        direction="column"
        style={{
          height: `100%`,
        }}
      >
        <AnalyticsHeader />

        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{
            flex: 1,
            padding: `0 20px`,
          }}
        >
          <AnalyticsBinTypeContainer />

          <AnalyticsDateRangeContainer />

          <VSpacer medium />

          {tab === `distance` && <AnalyticsDistance />}

          {tab === `stops` && <AnalyticsStops />}

          {tab === `emissions` && <AnalyticsEmissions />}
        </Grid>
      </Grid>
    </Grid>
  );
};
